import { createFileRoute } from '@tanstack/react-router'
import SoilProperties from '@/components/field/insights/SoilProperties'
import TissueProperties from '@/components/field/insights/TissueProperties'

export const Route = createFileRoute(
  '/dashboard/fields/$fieldId/insights/samples',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex flex-col gap-2 mt-4">
      <SoilProperties />
      <TissueProperties />
    </div>
  )
}
